/**
 * Register and Log in for guests (designs/Caged Home: under Quick fight; D21). Shown only with
 * server progression (Milestone 4) and once the device is known to be a guest (from its saved
 * session at start: net/savedAccount.ts).
 */
import { useTranslation } from 'react-i18next';
import { serverProgress } from '../../net/config';
import { useApp } from '../../state/store';
import s from './AccountButtons.module.css';

export function useAccountButtonsShown(): boolean {
  const guest = useApp((st) => st.account?.guest === true);
  return serverProgress() && guest;
}

export function AccountButtons() {
  const { t } = useTranslation();
  const shown = useAccountButtonsShown();
  const openAuth = useApp((st) => st.openAuth);
  if (!shown) return null;
  return (
    <div className={s.row}>
      <button type="button" className={s.btn} onClick={() => openAuth('register')}>
        {t('screens.auth.register')}
        <span className={s.icon} aria-hidden="true">
          +
        </span>
      </button>
      <button type="button" className={s.btn} onClick={() => openAuth('login')}>
        {t('screens.auth.login')}
        <span className={s.icon} aria-hidden="true">
          →
        </span>
      </button>
    </div>
  );
}

/** The Result screen's line for guests (A3, D21): under the rewards, never a popup. */
export function KeepProgress() {
  const { t } = useTranslation();
  const guest = useApp((st) => st.account?.guest === true);
  const openAuth = useApp((st) => st.openAuth);
  if (!serverProgress() || !guest) return null;
  return (
    <div className={s.keep}>
      <span className={s.keepText}>{t('screens.result.keep.text')}</span>
      <button type="button" className={s.keepBtn} onClick={() => openAuth('register')}>
        {t('screens.result.keep.cta')}
      </button>
    </div>
  );
}
